import { FunctionComponent, SetStateAction } from "react";
import { Text, Button, Icon } from "@src/straps/base";
import LoginImage from "./login_image.png";
import classNames from "classnames";

export const AuthWrapper: FunctionComponent = ({ children }) => (
  <div className="flex h-screen w-screen overflow-y-auto overflow-x-hidden">
    <div className="flex h-full w-full flex-col lg:w-3/5">
      <div className="pb-5 pl-16 pt-10">
        <Logo />
      </div>
      <div className="flex h-full min-h-fit w-full flex-col justify-center gap-2 overflow-x-hidden px-16 pb-20 md:px-[104px] min-[1600px]:px-[250px]">
        {children}
      </div>
    </div>
    <div className="sticky top-0 flex h-full w-0 items-center justify-end lg:w-2/5">
      <img
        src={LoginImage}
        alt="A building"
        className="h-[95%] w-0 object-contain lg:w-auto lg:max-w-full"
      />
    </div>
  </div>
);

export const ErrorWrapper: FunctionComponent = ({ children }) => (
  <AuthWrapper>
    <div className="flex items-center justify-center py-24">
      <div className="flex flex-col items-center gap-6">
        <Icon name="warning" color="negative" size="extraLarge" />
        {children}
      </div>
    </div>
  </AuthWrapper>
);

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="20"
      viewBox="0 0 100 20"
      fill="none"
    >
      <g clipPath="url(#clip0_12374_210526)">
        <path
          d="M28.2553 8.26078C28.9097 7.69833 29.2736 6.89267 29.2736 5.93739C29.2736 4.00764 27.8555 2.63953 25.6729 2.63953H21.4724V15.0061H26.6186C28.9823 15.0061 30.5098 13.4884 30.5098 11.409C30.5098 9.87291 29.6734 8.72961 28.2553 8.26158V8.26078ZM25.4917 4.38207C26.7099 4.38207 27.3464 5.03812 27.3464 6.031C27.3464 7.02388 26.7099 7.71753 25.4917 7.71753H23.3645V4.38287H25.4917V4.38207ZM26.4553 13.2628H23.3638V9.42167H26.4553C27.8188 9.42167 28.5646 10.1897 28.5646 11.3514C28.5646 12.5131 27.8188 13.2628 26.4553 13.2628Z"
          fill="#001D23"
        />
        <path
          d="M36.1073 5.60046C34.5978 5.60046 33.2711 6.21891 32.3434 7.56782L33.4522 8.72951C34.1613 7.86785 34.8891 7.36141 35.9254 7.36141C37.1436 7.36141 37.8347 8.05426 37.8347 9.32876V9.92801H35.3069C33.307 9.92801 32.0154 10.9401 32.0154 12.5514C32.0154 14.1627 33.2515 15.2116 35.1249 15.2116C36.3611 15.2116 37.3435 14.762 37.9799 13.9747V15.0052H39.7619V9.44157C39.7619 6.89337 38.2524 5.60046 36.1073 5.60046ZM35.5255 13.6947C34.6525 13.6947 33.9622 13.2827 33.9622 12.477C33.9622 11.7274 34.526 11.3529 35.5443 11.3529H37.8354V11.5217C37.8354 12.777 36.7804 13.6955 35.5263 13.6955L35.5255 13.6947Z"
          fill="#001D23"
        />
        <path
          d="M46.2466 5.60053C43.6103 5.60053 41.519 7.6991 41.519 10.3969C41.519 13.0947 43.6103 15.2125 46.2466 15.2125C47.9193 15.2125 49.2289 14.3692 50.0106 13.0763L48.6651 12.0082C48.0653 12.8515 47.3196 13.3948 46.2646 13.3948C44.6278 13.3948 43.4643 12.1019 43.4643 10.3969C43.4643 8.69198 44.6278 7.41748 46.2646 7.41748C47.3375 7.41748 48.0833 7.97992 48.6651 8.82239L50.0106 7.7359C49.2469 6.443 47.9381 5.59973 46.2466 5.59973V5.60053Z"
          fill="#001D23"
        />
        <path
          d="M51.7644 15.0061H53.6737V0.953735H51.7644V15.0061ZM55.9828 9.85365L59.5836 5.80692H57.2198L53.7284 9.83525L57.6016 15.0061H59.8928L55.9836 9.85365H55.9828Z"
          fill="#001D23"
        />
        <path
          d="M66.1831 5.60053C64.8735 5.60053 63.7279 6.16298 63.0735 7.11825V5.80695H61.2915V18.3784H63.2008V13.9004C63.8919 14.7437 64.9828 15.2117 66.1831 15.2117C68.7288 15.2117 70.5655 13.1507 70.5655 10.3961C70.5655 7.6415 68.7288 5.59973 66.1831 5.59973V5.60053ZM65.8738 13.414C64.5283 13.414 63.1828 12.4771 63.1828 10.3977C63.1828 8.31835 64.5463 7.39988 65.8738 7.39988C67.4192 7.39988 68.6015 8.63678 68.6015 10.4161C68.6015 12.1955 67.4013 13.414 65.8738 13.414Z"
          fill="#001D23"
        />
        <path
          d="M76.1996 5.60046C74.6901 5.60046 73.3634 6.21891 72.4356 7.56782L73.5445 8.72951C74.2536 7.86785 74.9814 7.36141 76.0176 7.36141C77.2358 7.36141 77.9269 8.05426 77.9269 9.32876V9.92801H75.3992C73.3993 9.92801 72.1077 10.9401 72.1077 12.5514C72.1077 14.1627 73.3438 15.2116 75.2172 15.2116C76.4534 15.2116 77.4358 14.762 78.0722 13.9747V15.0052H79.8542V9.44157C79.8542 6.89337 78.3447 5.60046 76.1996 5.60046ZM75.6178 13.6947C74.7448 13.6947 74.0537 13.2827 74.0537 12.477C74.0537 11.7274 74.6175 11.3529 75.6358 11.3529H77.9269V11.5217C77.9269 12.777 76.8719 13.6955 75.6178 13.6955V13.6947Z"
          fill="#001D23"
        />
        <path
          d="M86.3396 5.60053C83.7033 5.60053 81.6121 7.6991 81.6121 10.3969C81.6121 13.0947 83.7033 15.2125 86.3396 15.2125C88.0123 15.2125 89.3219 14.3692 90.1036 13.0763L88.7581 12.0082C88.1584 12.8515 87.4126 13.3948 86.3576 13.3948C84.7208 13.3948 83.5573 12.1019 83.5573 10.3969C83.5573 8.69198 84.7208 7.41748 86.3576 7.41748C87.4306 7.41748 88.1763 7.97992 88.7581 8.82239L90.1036 7.7359C89.3399 6.443 88.0303 5.59973 86.3396 5.59973V5.60053Z"
          fill="#001D23"
        />
        <path
          d="M91.8723 15.0061H93.7816V0.953735H91.8723V15.0061ZM96.0907 9.85365L99.6915 5.80692H97.3277L93.8363 9.83525L97.7095 15.0061H100.001L96.0915 9.85365H96.0907Z"
          fill="#001D23"
        />
        <path
          d="M79.3303 17.4663C78.6251 17.4663 78.0723 18.0143 78.0723 18.7288C78.0723 19.4432 78.6212 19.9913 79.3303 19.9913C79.8215 19.9913 80.2377 19.728 80.4431 19.3472V18.6583H79.3264V19.0064H80.0604V19.2696C79.916 19.492 79.67 19.64 79.3483 19.64C78.8274 19.64 78.4697 19.2512 78.4697 18.7256C78.4697 18.1999 78.8165 17.8255 79.3264 17.8255C79.6372 17.8255 79.8722 17.9703 80.0386 18.2103L80.3166 17.9767C80.0925 17.6543 79.7489 17.4655 79.3295 17.4655L79.3303 17.4663Z"
          fill="#001D23"
        />
        <path
          d="M85.2018 19.9513L84.4865 18.944C84.7723 18.8296 84.9457 18.5776 84.9457 18.2551C84.9457 17.8111 84.6201 17.5071 84.1359 17.5071H83.2644V19.9513H83.6478V19.0072H84.0851L84.7645 19.9513H85.2018ZM83.6478 17.8551H84.1289C84.3998 17.8551 84.5521 18.0215 84.5521 18.2583C84.5521 18.4952 84.4006 18.6584 84.1289 18.6584H83.6478V17.8551Z"
          fill="#001D23"
        />
        <path
          d="M89.207 17.4663C88.5128 17.4663 87.9568 18.0144 87.9568 18.7288C87.9568 19.4433 88.5097 19.9913 89.207 19.9913C89.9044 19.9913 90.4611 19.4473 90.4611 18.7288C90.4611 18.0104 89.8973 17.4663 89.207 17.4663ZM89.2109 17.8255C89.699 17.8255 90.0676 18.2104 90.0676 18.7256C90.0676 19.2409 89.699 19.6329 89.2109 19.6329C88.7229 19.6329 88.3543 19.2513 88.3543 18.7256C88.3543 18.2 88.7158 17.8255 89.2109 17.8255Z"
          fill="#001D23"
        />
        <path
          d="M95.1639 17.5071H94.7804V18.988C94.7804 19.4176 94.5204 19.6321 94.1877 19.6321C93.8551 19.6321 93.588 19.4176 93.588 18.988V17.5071H93.2046V18.9624C93.2046 19.6144 93.62 19.9921 94.1877 19.9921C94.7555 19.9921 95.1639 19.6144 95.1639 18.9624V17.5071Z"
          fill="#001D23"
        />
        <path
          d="M99.191 17.5071H98.3203V19.9513H98.7037V19.0072H99.1918C99.6759 19.0072 100.002 18.696 100.002 18.2551C100.002 17.8143 99.6759 17.5071 99.1918 17.5071H99.191ZM99.184 17.8551C99.4589 17.8551 99.6072 18.0215 99.6072 18.2583C99.6072 18.4952 99.4589 18.6584 99.184 18.6584H98.7029V17.8551H99.184Z"
          fill="#001D23"
        />
        <path
          d="M11.715 7.99902H0.00146484V20H11.715V7.99902Z"
          fill="#006058"
        />
        <path
          d="M0 0H7.80902C9.96431 0 11.7135 1.79214 11.7135 4.00032V8.00064H0V0Z"
          fill="#00C8B5"
        />
        <path
          d="M15.6182 11.9993V15.9997C15.6182 18.2078 13.8689 20 11.7137 20V7.99902C13.8689 7.99902 15.6182 9.79117 15.6182 11.9993Z"
          fill="#48CA2D"
        />
      </g>
      <defs>
        <clipPath id="clip0_12374_210526">
          <rect width="100" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Heading({
  text,
  description,
}: Readonly<{ text: string; description?: string }>) {
  return (
    <div className="pb-12">
      <Text variant="h1_t-42-500" className="!font-bold">
        {text}
      </Text>
      {description && (
        <Text className="pt-6" variant="sb_t-14-500">
          {description}
        </Text>
      )}
    </div>
  );
}

export function PasswordVisibilityToggle({
  showPassword,
  setShowPassword,
  className = "-right-0 bottom-5 mr-4",
}: Readonly<{
  showPassword: boolean;
  setShowPassword: (value: SetStateAction<boolean>) => void;
  className?: string;
}>) {
  return (
    <div className={classNames("absolute", className)}>
      <Button
        type="button"
        noFrameVariant="icon"
        color="secondary"
        className="opacity-50"
        icon={showPassword ? "hide" : "show"}
        onClick={() => setShowPassword((prev) => !prev)}
      />
    </div>
  );
}
